import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images } from "./images";

import { mc } from "../characters/MC";
import { doDoorRing, doPhoneRing, doTransition, doWaitImageByTime, isAnnCorrupted, isAnnGF } from "../helpers/helpers";
import { Phone } from "../../src/components/phoneUI/PhoneClass";
import { ann } from "../characters/Ann";
import { shouldShowAnnChrisDormScene, V9AnnMCNightConvAfter } from "./V9";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";

const v9 = images.v9;
export const V9AnnMCNightConv = async (): Promise<any> => {
    if (isAnnCorrupted()) {
        mc.think(`Ann wanted to talk to me. I better text her that I'm free.`);
        await Phone.showMessagesUI({ name: ann.name }, async () => {
            Phone.setMessage({ character: mc.character, text: `Hey sweetie.\nYou wanted to talk. I'm free right now.`, options: { wait: false } });
            Phone.setMessage({ character: ann.character, text: `Great! I'll be there in a few!` });
            Phone.setMessage({ character: mc.character, text: `You can talk over the phone if it's too much trouble.` });
            Phone.setMessage({ character: ann.character, text: `It's not! And I wanted to show you something as well 😜` });
            Phone.closeMessagesUI();
        });

        mc.think(`Ann should arrive shortly...`);
        doTransition(v9.V9AnnCorNight_7);
        ann.talk(`Hey!`);
        ann.talk(`I insisted on coming because I wanted you to see my new outfit!`);
        await ann.setQuestion(new Question({ text: `What do you think?`, options: { think: false }, key: `v9AnnCorNightComplimentedHer` })
            .option({ title: `Compliment her`, key: true })
            .option({ title: `Don't compliment`, key: false }));

        if (Question.globalAnswers.v9AnnCorNightComplimentedHer) {
            mc.talk(`I love it! You look hot!`);
            ImageClass.setImage(images.v9.V9AnnCorNight_14);
            ann.talk(`Hehe, thank you!`);
            ImageClass.setImage(v9.V9AnnCorNight_7);
            ann.talk(`I tried it on and really loved it and knew you'd want to see it!`);
            mc.talk(`You did good! Now I'll have something to dream about.`);
            ImageClass.setImage(images.v9.V9AnnCorNight_14);
            ann.talk(`Hehe.`);
        } else {
            mc.talk(`It's nice.`);
            ImageClass.setImage(images.v9.V9AnnCorNight_15);
            ann.talk(`Oh... I thought you'd like it more...`);
        }

        mc.talk(`What did you want to talk about?`);
        doWaitImageByTime(images.v9.V9AnnCorNight_16);
        ann.talk(`Let's sit down.`);
        doWaitImageByTime(v9.V9AnnCorNight_4);
        mc.talk(`What is it?`);
    } else {
        mc.think(`I couldn't get a hold of Ann earlier; she must be available right now.`);
        doWaitImageByTime(images.v9.V9MCRoomAnnWebcam_6);
        mc.think(`Let's see if Ann is available to chat right now.`);
        mc.think(`Ringing...`);
        doWaitImageByTime(images.v9.V9MCRoomAnnWebcam_7);
        ann.talk(`Hey!`);
        ImageClass.setImage(images.v9.V9AnnDormNightChris_25);
        mc.talk("Hey!");
        mc.talk("Is that a new haircut?");
        ImageClass.setImage(images.v9.V9AnnDormNightChris_27);
        ann.talk("Hehe, not really. It's my usual hairstyle, I just tied it up.");
        ImageClass.setImage(images.v9.V9AnnDormNightChris_26);
        ann.talk(`See?`);
        mc.talk(`Oh! Nice. I like it!`);
        ImageClass.setImage(images.v9.V9AnnDormNightChris_27);
        ann.talk(`Thank you!`);

        ImageClass.setImage(images.v9.V9AnnDormNightChris_25);
        mc.talk(`What did you want to talk about?`);
        ImageClass.setImage(images.v9.V9AnnDormNightChris_28);
        ann.talk(`Hmm... How do I start...`);
    }

    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_17);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_29);
    }
    ann.talk(`It might sound a bit strange and out of place...`);
    ann.talk(`But I'll kick myself if I don't ask.`);
    ann.talk(`So...`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_17);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_30);
    }
    ann.talk(`You know Alex, right?`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_4);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_31);
    }
    mc.talk(`Yeah...`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_18);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_28);
    }
    ann.talk(`So... I had a chat with her and she's in a weird place right now...`);
    ann.talk(`She says all guys suck and she can't find a normal guy to date because they all want one thing from her...`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_19);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_29);
    }
    ann.talk(`I told her that's not true and there are great guys out there.`);
    ann.talk(`She refused to accept it because of past experiences...`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_18);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_30);
    }
    ann.talk(`Anyway... one thing led to another and I kinda suggested that you could maybe take her out and show her I'm right.`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_4);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_31);
    }
    mc.talk(`You kinda suggested?`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_18);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_30);
    }
    ann.talk(`Hmm...`);
    if (isAnnCorrupted()) {
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_28);
    }
    ann.talk(`Mmm... Maybe I outright offered that you take her out on a date and show her how a real man behaves.`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_4);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_31);
    }
    mc.talk(`What did she say?`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_17);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_30);
    }
    ann.talk(`She called me crazy at first, but I managed to convince her.`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_4);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_31);
    }
    mc.talk(`Wow. That came out of the blue.`);
    mc.talk(`And what about you? Are you still on board with this, or are you having second thoughts?`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_19);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_30);
    }
    ann.talk(`I've had a lot of time to think about it and I still think it's a good idea.`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_6);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_29);
    }
    ann.talk(`It still depends if you agree to it or not.`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_5);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_31);
    }
    mc.talk(`I might... But have you really considered everything?`);
    mc.talk(`If I am to take her on a date, I can't just hold myself back and think about what I can and can't do.`);
    mc.talk(`What happens if things go too far...? Have you considered that?`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_19);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_28);
    }
    ann.talk(`I have. And Alex mentioned that as well.`);
    ann.talk(`I want you to show her how a real date feels like without holding yourself back...`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_17);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_29);
    }
    ann.talk(`I mean... I can't lie to myself, I'd be happy if nothing happens, but I also won't get jealous if it did.\nI promise.`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_18);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_30);
    }
    ann.talk(`What do you say...? Is that a yes?`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_5);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_31);
    }
    mc.talk(`I must say I wasn't expecting that.`);
    mc.talk(`Funny enough, I'll do it for you.`);
    if (isAnnCorrupted()) {
        ImageClass.setImage(images.v9.V9AnnCorNight_6);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_27);
    }
    ann.talk(`Really? Thank you!`);
    if (isAnnCorrupted()) {
        doWaitImageByTime(v9.V9AnnCorNight_7);
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_25);
    }
    ann.talk(`That's it!`);
    if (isAnnCorrupted()) {
    } else {
        ImageClass.setImage(images.v9.V9AnnDormNightChris_27);
    }
    ann.talk(`I'm glad I finally got it off my chest.`);
    if (isAnnCorrupted()) {
        mc.talk(`Before you go...`);
        ann.talk(`Yes?`);
        mc.talk(`Why don't you show me those breasts of yours? I missed them.`);
        ImageClass.setImage(v9.V9AnnCorNight_9);
        ann.talk(`Hehe. I had a feeling you'd ask.`);
        ImageClass.setImage(v9.V9AnnCorNight_8);
        mc.talk(`How can't I?`);
        ImageClass.setImage(v9.V9AnnCorNight_10);
        ann.talk(`Anything else?`);
        mc.talk(`Yes.`);
        mc.talk(`Lift your dress.`);
        ImageClass.setImage(v9.V9AnnCorNight_12);
        ann.talk(`Okay!`);
        ImageClass.setImage(v9.V9AnnCorNight_11);
        mc.talk(`Sexy panties.`);
        ImageClass.setImage(v9.V9AnnCorNight_13);
        mc.talk(`I love them.`);
        mc.talk(`Now you got me so horny.`);
        ImageClass.setImage(v9.V9AnnCorNight_23);
        ann.talk(`But I can't! I promised my parents I'd be back in five minutes.`);
        ImageClass.setImage(v9.V9AnnCorNight_24);
        mc.talk(`They let you leave the house dressed like that but will be mad if you're ten minutes late?`);
        ImageClass.setImage(v9.V9AnnCorNight_22);
        ann.talk(`I copy from Vanessa and hide what I'm wearing.`);
        return jump(V9AnnMCNightConv_Quicky, "V9AnnMCNightConv_Quicky");

    } else {
        ann.talk(`I gotta do some stretches and go to sleep! Big day tomorrow.`);
        mc.talk(`Good night.`);
    }
    if (isAnnCorrupted()) {
        doWaitImageByTime(v9.V9AnnCorNight_20);
    } else {
        doWaitImageByTime(v9.V9AnnDormNightChris_32);
    }

    ann.talk(`Talk to you later! Muah!`);
    if (isAnnCorrupted()) {
        doWaitImageByTime(v9.V9AnnCorNight_21, null, 2);
    } else {
        if (shouldShowAnnChrisDormScene()) {
            doWaitImageByTime(v9.V9MCRoomAnnWebcam_9, null, 2);
        } else {
            doWaitImageByTime(v9.V9MCRoomAnnWebcam_9, null, 2);
        }
    }
    mc.think(`Wow... I certainly didn't expect that.`);
    if (mc.properties.alexRelationship > 2) {
        mc.think(`But do I really care? Alex is hot. I wouldn't mind spending some time with her...`);
        mc.think(`And with my girlfriend's approval, nonetheless.`);
    }

    return jump(V9AnnMCNightConv_End, "V9AnnMCNightConv_End");
};

export const V9AnnMCNightConv_Quicky = async (): Promise<any> => {
    ImageClass.setImage(v9.V9AnnCorNight_24);
    await mc.setQuestion(new Question({ text: `Interesting...`, options: { think: true }, key: `v9AnnCorNightAskForHandjob` })
        .option({ title: `Ask for a quick Handjob`, key: true })
        .option({ title: `Wish her goodnight`, key: false }));

    if (Question.globalAnswers.v9AnnCorNightAskForHandjob) {
        mc.talk(`Come on... How about a quick handjob?`);
        mc.talk(`You turned me on so much you can't just leave like that!`);
        ImageClass.setImage(images.v9.V9AnnCorNight_13);
        ann.talk(`Hehe... Okay! But a quick one!`);
        mc.talk(`I'm already turned on; it will take two seconds!`);
        doWaitImageByTime(v9.Anim_V9AnnCorNightHJ.poster);
        ImageClass.setAnimation(images.v9.Anim_V9AnnCorNightHJ);
        mc.talk(`Ah...`);
        mc.talk(`Fuck. Keep going!`);
        ImageClass.setAnimation(images.v9.Anim_V9AnnCorNightHJ, { speed: 3 });
        mc.talk(`Just like that...`);
        ImageClass.setAnimation(images.v9.Anim_V9AnnCorNightHJCum, { loop: 0, waitForEnd: true });
        mc.talk(`Ahhh!!!`);
        ann.talk(`It was quick!`);
        mc.talk(`I told you.`);
        mc.talk(`Fuck, now I gotta clean the carpet.`);
        ann.talk(`I have to go now! I'm already late!`);
        await endReplay(replayScenesList.V9AnnMCNightConv_Quicky);
    } else {
        mc.talk(`I don't want you to get into trouble.`);
        mc.talk(`Good night!`);
        await endReplay();
    }

    return jump(V9AnnMCNightConv_End, "V9AnnMCNightConv_End");
};

export const V9AnnMCNightConv_End = async (): Promise<any> => {
    return jump(V9AnnMCNightConvAfter, "V9AnnMCNightConvAfter");
};